import img1 from "../../../assests/ourservice/feedback.svg";
import img2 from "../../../assests/ourservice/standing-ovation.svg";

const SERVICES = [
  {
    _id: 1,
    title: "Space Planning",
    icon: img1,
    service: `Sample text. Click to select the text box. Click again or
double click to start editing the text. Excepteur sint
occaecat cupidatat non proident.`,
  },
  {
    _id: 2,
    title: "Space Planning",
    icon: img2,
    service: `Sample text. Click to select the text box. Click again or
double click to start editing the text. Excepteur sint
occaecat cupidatat non proident.`,
  },
  {
    _id: 3,
    title: "Space Planning",
    icon: img1,
    service: `Sample text. Click to select the text box. Click again or
double click to start editing the text. Excepteur sint
occaecat cupidatat non proident.`,
  },
];

export default SERVICES;
